import { getMarbleContent, UserMarble } from "@hoylu/client-common";
import React from "react";
import type { ProjectUsersResponse } from "../state/workspaces/types";
import Styles from "./UserDetail.module.css";

type UserDetailProps = {
  userDetail: ProjectUsersResponse;
};

export const UserDetail = ({ userDetail }: UserDetailProps) => {
  const firstAndLastName = [userDetail.firstName, userDetail.lastName].filter(
    Boolean,
  );

  const marbleContent = getMarbleContent(
    ...(firstAndLastName.length ? firstAndLastName : [userDetail.email]),
  );

  return (
    <div className={Styles.container}>
      <UserMarble className={Styles.marble} email={userDetail.email}>
        {marbleContent}
      </UserMarble>
      <div className={Styles.details}>
        <div className={Styles.name}>
          {userDetail.firstName} {userDetail.lastName}
        </div>
        <div className={Styles.email}>{userDetail.email}</div>
        <div className={Styles.orgName}>{userDetail.orgName}</div>
      </div>
    </div>
  );
};
